<div
  class="container flex"
  #container
  [ngClass]="{ invisible: !isInitialized, 'flex-col': wrap }"
>
  <span
    (click)="navigateToTag(tag)"
    [ngClass]="getTagColor(tag, allTags)"
    class="p-1 rounded-md mr-2 cursor-pointer rounded-xl px-2 tag"
    *ngFor="let tag of visibleTags; trackBy: trackByTagId"
    >#{{ tag.fullPath }}</span
  >
  <span *ngIf="hiddenCount > 0">+{{ hiddenCount }}</span>
</div>
